/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ReportsInputs */

const vi_nav_reports = /** @type {(inputs: Nav_ReportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Báo cáo`)
};

/**

* @param {Nav_ReportsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_reports = /** @type {((inputs?: Nav_ReportsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ReportsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_reports(inputs)
});